import { render } from "./PlanPricing.vue?vue&type=template&id=33757171&scoped=true"
import script from "./PlanPricing.vue?vue&type=script&lang=js"
export * from "./PlanPricing.vue?vue&type=script&lang=js"

import "./PlanPricing.vue?vue&type=style&index=0&id=33757171&scoped=true&lang=scss"

import exportComponent from "/home/github-runner/actions-runner/_work/acutame/acutame/src/main/front/merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33757171"]])

export default __exports__